import { FC, ReactElement } from 'react';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { dynamicCustomEventTracking } from '../../../lib/gtm';
import { Body, Content, InfoGroup, Root, ViewDetails } from './styled';
import { formatDateLabel, scheduleIsEnded } from '../../../lib/dayjs';
import { IJourneyResp, ISchedules } from '../../../services/journey.service';
import JourneyScheduleDots from '../JourneyScheduleDots';

export type JourneyCardVariant = 'active' | 'finalized';

interface Props {
  actionButton?: ReactElement;
  journey: IJourneyResp;
  schedule: ISchedules;
  variant?: JourneyCardVariant;
}

export const JourneyWithNextSchedule: FC<Props> = ({ journey, actionButton, schedule, variant = 'active' }) => {
  const {
    dateStart,
    dateEnd,
    calendarServiceType: { alias }
  } = schedule;
  const {
    journeyid,
    schedules,
    product: { alias: productAlias, name: productName }
  } = journey;
  const navigate = useNavigate();
  const openUrl = () => {
    dynamicCustomEventTracking.send({
      dynamicEventName: `clique_jornada_mc`
    });
    navigate(`/jornada/${journeyid}`);
  };
  const showScheduleInfo = variant === 'finalized' || !!dateStart;
  const scheduleInfoLabel =
    variant === 'finalized' || scheduleIsEnded(dateEnd) ? 'Último atendimento:' : 'Próximo atendimento:';

  return (
    <Root
      variant={variant}
      className={
        variant !== 'finalized' && scheduleIsEnded(dateEnd)
          ? 'journey-without-active-schedule'
          : 'journey-with-active-schedule'
      }
    >
      <Body>
        <Content>
          {productAlias || productName ? (
            <Typography
              variant="body1B"
              color="brand.darkGreen"
              sx={{ cursor: 'pointer' }}
              onClick={() => {
                openUrl();
              }}
            >
              {productAlias ? productAlias : productName}
            </Typography>
          ) : null}

          <JourneyScheduleDots schedules={schedules} variant={variant} />

          {showScheduleInfo ? (
            <InfoGroup>
              <Typography variant="body2B" color="neutrals.lead">
                {scheduleInfoLabel}
              </Typography>
              {alias && (
                <Typography variant="body2R" color="neutrals.lead">
                  {alias}
                </Typography>
              )}
              {dateStart && (
                <Typography variant="body2R" color="neutrals.lead">
                  {formatDateLabel(dateStart)}
                </Typography>
              )}
            </InfoGroup>
          ) : null}
        </Content>
        {actionButton}
      </Body>
      <ViewDetails onClick={() => openUrl()} variant="inline" color="primary">
        ver detalhes
      </ViewDetails>
    </Root>
  );
};

export default JourneyWithNextSchedule;
